module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.scss
// module id = ./src/app/user/user.component.scss
// module chunks = main